module.exports = __webpack_public_path__ + "img/FF_Info_Game_7.0aab0b49.png";